import React, { Fragment } from "react";
import PropTypes from "prop-types";

const DocImgView = props => {
  let pic = props.pic.split(".");
  return (
    <Fragment>
      {pic[pic.length - 1] !== "pdf" && (
        <img
          className={props.className}
          onClick={props.clickEvent}
          src={props.pic}
          alt="doc-img"
        />
      )}
      {pic[pic.length - 1] === "pdf" && (
        <Fragment>
          <a
            className="download-btn mr-2"
            href={props.pic.indexOf("http") !== -1 ? props.pic : "#"}
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fas fa-download"></i>
          </a>
          <a
            className="ic-doc-prof-link pt-2"
            href={props.pic.indexOf("http") !== -1 ? props.pic : "#"}
            target="_blank"
            rel="noopener noreferrer"
          >
            {props.picName}
          </a>
        </Fragment>
      )}
    </Fragment>
  );
};

export default DocImgView;

DocImgView.defaultProps = {
  pic: "",
  className: "",
  picName: "",
  clickEvent: () => {}
};

DocImgView.propTypes = {
  pic: PropTypes.string,
  clickEvent: PropTypes.func,
  className: PropTypes.string,
  picName: PropTypes.string
};
